import loggerService from './logger.service';

export enum UserRole {
  EVENT_MEMBER = 0,
  ADMIN = 2,
  BROADCAST_SPEAKER = 4,
  SPONSOR = 6,
  RECORDER_BOT = 7,
  STAFF = 9
}

export function getInitials(text: string) {
  try {
    if (!text) {
      return '.';
    }
    return text
      .trim()
      .split(' ')
      .slice(0, 2)
      .map(x => x[0] || '')
      .join('');
  } catch (err) {
    loggerService.error('Error in getInitials', err);
    return '.';
  }
}

export function getUserInitials(user: any) {
  return getInitials(user ? user.name || user.email : '');
}
